import { gql } from 'apollo-boost';

export const uploadQuery = gql`
  mutation($file: Upload!) {
    Upload(file: $file) {
      id
      filename
      contentLength
      fileType
      url
      thumbnailUrl
    }
  }
`;
